import {useState} from "react";


export const useForceUpdate = () => {
    const [lastUpdate, setLastUpdate] = useState(0);
    return () => setLastUpdate(Math.random())
}